import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Grid } from "@masterteam/mt-design-react";

import DataChart from "../DataChart";
import ChartCard from "../ChartCard";
import KPIsListModal from "../KPIsListModal";
import UpdateStatus from "../UpdateStatus";
import PerspectiveKPIs from "../PerspectiveKPIs";

import "./style.scss";

const { Row, Col } = Grid;

const Charts = ({ data, kpisStatuses }) => {
  const intl = useIntl();
  const [openModal, setOpenModal] = useState(false);
  const [KPIsPopupList, setKPIsPopupList] = useState([]);

  return (
    <Row className="executive-dashboard__charts" gap={16}>
      <Col span={12}>
        <ChartCard
          title={intl.formatMessage({
            id: "kpis-dashboard.kpi-by-status",
          })}
        >
          <DataChart
            data={data?.KPIByStatuses || []}
            statuses={kpisStatuses}
            title={intl.formatMessage({ id: "kpis-dashboard.kpi" })}
          />
        </ChartCard>
      </Col>

      <Col span={12}>
        <ChartCard
          title={intl.formatMessage({
            id: "kpis-dashboard.kpi-by-update-status",
          })}
        >
          <UpdateStatus
            data={data.KPIByUpdateStatuses}
            oldestDueDate={data?.OldestDueDate}
            onShowPopup={(kpis) => {
              setKPIsPopupList(kpis);
              setOpenModal(true);
            }}
          />
        </ChartCard>
      </Col>

      <Col span={12}>
        <ChartCard
          title={intl.formatMessage({
            id: "kpis-dashboard.kpi-by-perspective",
          })}
        >
          <PerspectiveKPIs
            items={data.KPIByPerspectives}
            KPIsStatus={kpisStatuses}
            onShowPopup={() => {}}
          />
        </ChartCard>
      </Col>

      {openModal ? (
        <KPIsListModal
          isOpen={openModal}
          closeModal={() => setOpenModal(false)}
          data={KPIsPopupList}
        />
      ) : null}
    </Row>
  );
};

export default Charts;
